import React from "react";

import SolarModel from "../components/solar/SolarModel";

const Solar = () => {
  return <SolarModel />;
};

export default Solar;
